import dynamic from 'next/dynamic'

const SuccessPage = dynamic(() => import('../SuccessPage'))

const AccountEditPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountEditPage)
)
const AccountOrderDetailPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountOrderDetailPage)
)
const AccountOrderListPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountOrderListPage)
)
const AccountOverviewPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountOverviewPage)
)
const AccountRegularDeliveriesPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountRegularDeliveriesPage)
)
const AccountReorderPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountReorderPage)
)
const AccountLogoutPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountLogoutPage)
)
const AccountContactPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountContactPage)
)
const AccountConfirmPage = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountConfirmPage)
)
const AccountResetPassword = dynamic(() =>
  import('../CustomerAccount').then((m) => m.AccountResetPassword)
)

const PaymentReviewPage = dynamic(() =>
  import('../../patterns/Alphapet/Payment/Review')
)
const PaymentAddressCorrectionPage = dynamic(() =>
  import('../../patterns/Alphapet/Payment/AddressCorrection')
)
const CartPage = dynamic(() => import('../CartPage'))

const NewsletterSubscribe = dynamic(() =>
  import('../../patterns/Alphapet/Newsletter/NewsletterSubscribe')
)
const NewsletterUnSubscribe = dynamic(() =>
  import('../../patterns/Alphapet/Newsletter/NewsletterUnSubscribe')
)
const NewsletterOptOut = dynamic(() =>
  import('../../patterns/Alphapet/Newsletter/NewsletterOptOut')
)

const ErrorPage = dynamic(() => import('../ErrorPage'))

const staticRoutes = [
  {
    url: '/checkout/onepage/success',
    component: SuccessPage,
  },
  {
    url: '/checkouttester/index/success',
    component: SuccessPage,
    parameter_to_props: ['order_id'],
  },
  {
    url: '/checkout/shopify/success',
    component: SuccessPage,
    parameter_to_props: ['order_id'],
  },
  {
    url: '/customer/account',
    component: AccountOverviewPage,
  },
  {
    url: '/customer/account/confirm',
    component: AccountConfirmPage,
  },
  {
    url: '/customer/account/edit',
    component: AccountEditPage,
  },
  {
    url: '/customer/account/resetpassword',
    component: AccountResetPassword,
  },
  {
    url: '/customer/account/logout',
    component: AccountLogoutPage,
  },
  {
    url: '/sales/order/history',
    component: AccountOrderListPage,
  },
  {
    url: '/sales/order/view',
    component: AccountOrderDetailPage,
  },
  {
    url: '/customer/account/contact',
    component: AccountContactPage,
  },
  {
    url: '/paypal/express/review',
    component: PaymentReviewPage,
  },
  {
    url: '/payment/addresscorrection',
    component: PaymentAddressCorrectionPage,
  },
  {
    url: '/checkout/cart',
    component: CartPage,
  },
  {
    url: '/cartUpdate/abodelivery/view',
    component: AccountRegularDeliveriesPage,
  },
  {
    url: '/reorder/category/view',
    component: AccountReorderPage,
  },
  {
    url: '/newsletter-subscribe/token/:token/id/:id',
    component: NewsletterSubscribe,
  },
  {
    url: '/newsletter-unsubscribe/token/:token/id/:id',
    component: NewsletterUnSubscribe,
  },
  {
    url: '/newsletter-optout',
    component: NewsletterOptOut,
  },
  {
    url: '/404',
    component: ErrorPage,
  },
]

export { staticRoutes }
